import type { PortalDashboardPageDefinition } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';

export const LAW_FIRM_DASHBOARD_PAGES: readonly PortalDashboardPageDefinition[] = [
  {
    path: 'dashboard',
    label: 'Overview',
    icon: 'home',
    loadComponent: () =>
      import('../dashboard/dashboard').then((m) => m.Dashboard),
  },
  {
    path: 'applications',
    label: 'Applications',
    icon: 'appstore',
    permission: 'applications',
    loadComponent: () =>
      import('../applications/applications').then((m) => m.Applications),
  },
  {
    path: 'drafts',
    label: 'Drafts',
    icon: 'file',
    permission: 'drafts',
    loadComponent: () => import('../drafts/drafts').then((m) => m.Drafts),
  },
  {
    path: 'archived',
    label: 'Archived',
    icon: 'inbox',
    permission: 'archived',
    loadComponent: () => import('../archived/archived').then((m) => m.Archived),
  },
  {
    path: 'tickets',
    label: 'Tickets',
    icon: 'mail',
    permission: 'tickets',
    loadComponent: () =>
      import('@dlap-ui/shared-forms/tickets/tickets-page/tickets-page').then((m) => m.TicketsPage),
  },
  {
    path: 'wallet',
    label: 'Wallet',
    icon: 'wallet',
    permission: 'wallet',
    loadComponent: () => import('../wallet/wallet').then((m) => m.Wallet),
  },
  {
    path: 'fees',
    label: 'Fees',
    icon: 'dollar',
    permission: 'fees',
    loadComponent: () => import('../fees/fees').then((m) => m.Fees),
  },
  {
    path: 'users',
    label: 'Users',
    icon: 'team',
    permission: 'users',
    loadComponent: () => import('../users/users').then((m) => m.Users),
  },
  {
    path: 'memberships/members',
    label: 'Members',
    icon: 'team',
    permission: 'memberships/members',
    loadComponent: () => import('../members/members').then((m) => m.Members),
  },
  {
    path: 'individuals-biometrics',
    label: 'Individuals Biometrics',
    icon: 'idcard',
    permission: 'individuals-biometrics',
    loadComponent: () =>
      import('../individuals-biometrics/individuals-biometrics').then((m) => m.IndividualsBiometrics),
  },
  {
    path: 'profile',
    label: 'Profile',
    icon: 'idcard',
    showInMenu: false,
    loadComponent: () => import('@dlap-ui/shared-forms/profile/profile-page/profile-page').then((m) => m.ProfilePage),
  },
] as const;
